import React, { useEffect, useState } from 'react';
import './index.css';
import styled from 'styled-components';
import Footer from 'components/footer';
import { useForm } from 'react-hook-form';
import { useHistory } from "react-router-dom";
import { ENDPOINTS } from 'constants/endpoints';
import { useMediaQuery } from 'react-responsive';
import { AjaxError, AjaxResponse } from 'rxjs/ajax';
import useFlashToggler from 'hooks/use-flash-toggler';
import resolveURLParams from '__utils/url-params-resolver';
import { get_item_from_localStorage } from '__utils/storage';
import { get, getDefaultHeaders } from '__utils/ajax-wrapper';
import MobileFooterLayout from 'components/old-footer-layout';
import { getQueryParamsFromString, MFDetailsPageURLWithEncryptedId } from '__utils/common-utils';
import { LayoutContext } from 'components/app-routes';

export const PanelContainer = styled.div`
    height: 100vh;
    position: absolute;
    top: 0;
    z-index: 9999;
    width: 100vw;
    padding:16px;
    overflow: auto;
    background-color: #fff;
    margin-bottom: 60px;  
`;

const SearchPanel: React.FC = () => {
    const history = useHistory();
    const flash = useFlashToggler();
    const isMobile = useMediaQuery({ maxWidth: 767 });
    const [autoFunds, setAutoFunds] = useState<any>();
    const { SetLayoutProps } = React.useContext(LayoutContext);
    const { keywords } = getQueryParamsFromString(window.location.search);
    const [mostSearchedMFlist, setMostSearchedMFlist] = useState<any>();
    const [showAutoSuggest, setShowAutoSuggest] = useState<boolean>(false);
    const [recentSearchResults, setRecentSearchResults] = useState<any>([]);
    const { register, handleSubmit, reset } = useForm({ mode: 'onChange' });


    const searchFromInput = (data: any) => {
        history.push(`search?keywords=${data.keywords}`);
    }

    const showRecentSearches = () => {
        const itemFromStorage = get_item_from_localStorage('recentSearches');
        itemFromStorage && setRecentSearchResults(JSON.parse(itemFromStorage));
    }

    const getMostSearchedResults = () => {
        get(ENDPOINTS.GET_MOST_SEARCHED_MUTUAL_FUNDS, getDefaultHeaders(), true)
            .subscribe((response: AjaxResponse | AjaxError) => {
                if (response?.response?.length) {
                    setMostSearchedMFlist(response?.response?.slice(0, 5));
                    setShowAutoSuggest(false);
                }
                else {
                    showRecentSearches();
                }
            }, (error: AjaxError) => {
                flash.error('Something went wrong.');
            });
    }

    const getMFsuggestions = (inputData: any) => {
        if (inputData.length >= 4) {
            get(resolveURLParams(ENDPOINTS.GET_SUGGEST_MUTUAL_FUNDS, { text: inputData }, null), getDefaultHeaders(), true)
                .subscribe((response: AjaxResponse | AjaxError) => {
                    if (response?.response?.length) {
                        setAutoFunds(response?.response?.slice(0, 5));
                        setShowAutoSuggest(true);
                    }
                    else {
                        setShowAutoSuggest(false);
                        showRecentSearches();
                    }
                }, (error: AjaxError) => {
                    flash.error('Something went wrong.');
                });
        }
        else {
            setAutoFunds([]);
            setShowAutoSuggest(false);
            showRecentSearches();
        }

    }
    const getMFlist = () => {
        return showAutoSuggest ? autoFunds : mostSearchedMFlist?.length ? mostSearchedMFlist : recentSearchResults;
    }

    useEffect(() => {
        SetLayoutProps({
            config: {
                title: `Search`,
            },
        });
        getMostSearchedResults();
    }, [])

    return <PanelContainer>
        <div className='searchPanelGrid'>
            <i className="icon-Back headerIconSet" onClick={() => history.go(-1)}></i>
            <form onSubmit={handleSubmit(searchFromInput)}>
                <div className="searchInput">
                    <input
                        name='keywords'
                        type="text"
                        ref={register()}
                        defaultValue={keywords}
                        onChange={(event) => getMFsuggestions(event.target.value)}
                    />
                    <span className="searchClose" onClick={() => reset()}>&times;</span>
                </div>
            </form>
        </div>


        <div>
            {(showAutoSuggest || autoFunds?.length) ? <ul className='auto-suggest'>
                {getMFlist()?.map((mutualFundProductView: any, index: number) => <li key={index}>
                    <a href={MFDetailsPageURLWithEncryptedId(mutualFundProductView)}> <span>{mutualFundProductView?.schemeName}</span></a>
                </li>)}
            </ul> : (!showAutoSuggest && recentSearchResults.length) ? <ul className='auto-suggest'>
                {getMFlist()?.map((mutualFundProductView: any, index: number) => <li key={index}>
                    <a href={`search?keywords=${mutualFundProductView}`}> <span>{mutualFundProductView}</span></a>
                </li>)}
            </ul> : <></>
            }
        </div>

        {isMobile &&
            <Footer>
                <MobileFooterLayout />
            </Footer>
        }

    </PanelContainer>;
}

export default SearchPanel;
